import { render, staticRenderFns } from "./page_search.vue?vue&type=template&id=3701147e&scoped=true"
import script from "./page_search.vue?vue&type=script&lang=js"
export * from "./page_search.vue?vue&type=script&lang=js"
import style0 from "./page_search.vue?vue&type=style&index=0&id=3701147e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701147e",
  null
  
)

export default component.exports